import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function ObstetricsGayanocology() {
  return (
        <>
            <section className="general-surgery hide-on-mobile">
                <img
                    src={require("../assets/img/services/big-8.png")}
                    alt="General Surgery"
                    className="top-band-img"
                />
            </section>
            <section className="general-surgery-content">
                <div className="1stblock">
                    <span className="title">What is Obstetrics & Gynaecology?</span>
                    <p>
                        This specialty focuses on women’s health, pregnancy care, childbirth, and gynaecological conditions.
                    </p>
                </div>
                <div className="general-surgery-row">
                    <div className="general-surgery-col general-surgery-col-1">
                        <span className="subtitle">Services Include:</span>
                        <ul className="general-surgery-list">
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Antenatal and postnatal care
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Gynaecological evaluations and procedures
                            </li>
                            {/* <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Post-trauma and post-surgical reconstruction
                            </li> */}
                        </ul>
                    </div>
                    <div className="general-surgery-col general-surgery-col-2">
                        <span className="subtitle">Why This Service Matters</span>
                        <p>Women’s healthcare requires consistent monitoring, clear communication, and coordinated medical support.</p>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default ObstetricsGayanocology;
